import React, { FC } from 'react';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import selectors from 'src/redux/selectors';
import CheckboxActive from 'src/assets/icons/check/CheckboxActiveIcon';
import CheckboxUnactive from 'src/assets/icons/check/CheckboxUnactiveIcon';
import cls from '../Table.module.scss';
import { useAppDispatch } from 'src/redux';
import { toggleSelectedRows } from 'src/redux/slices/selectedRows';
interface TableCheckboxCellProps {
  id: number | string;
}
const TableCheckboxCell: FC<TableCheckboxCellProps> = ({ id }) => {
  const selectedRows = useTypedSelector(selectors.getSelectedRows);
  const dispatch = useAppDispatch();
  const toggleSelectedRow = (event: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(
      toggleSelectedRows({
        value: id,
        event: {
          altKey: event.altKey,
          shiftKey: event.shiftKey,
        },
      })
    );
  }
  return (
    <td className={cls['selection-cell']} onClick={toggleSelectedRow}>
      {selectedRows.includes(id) ? <CheckboxActive /> : <CheckboxUnactive />}
    </td>
  );
};

export default TableCheckboxCell;
